import './AreaIndicatorBasicCard.css';

import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Paper } from '@mui/material';
import useLevelNImagePathWithAPIKey from '../../../b2b-frameworks/hooks/useLevelNImagePathWithAPIKey';
import { fullImagePath } from '../../../b2b-common/helpers';

const SdgBullet = ({ sdg, iconsSize = 25 }) => {
    const sdgBullet = useLevelNImagePathWithAPIKey('generic', 2, sdg, null, 'bullet');
    return (
        <Avatar
            variant='square'
            src={fullImagePath(sdgBullet)}
            alt={`Impact ${sdg}`}
            sx={{ width: iconsSize, height: iconsSize }}
        />
    );
}

const AUEStObjectiveBullet = ({ stObj, iconsSize = 25 }) => {
    const sdgBullet = useLevelNImagePathWithAPIKey('generic', 1, stObj, null, 'bullet');
    return (
        <Avatar
            variant='square'
            src={fullImagePath(sdgBullet)}
            alt={`Impact ${stObj}`}
            sx={{ width: iconsSize, height: iconsSize }}
        />
    );
}

const AreaIndicatorBasicCard = ({ areaIndicator, atPublicDashboard = false, frameworkId = 2 }) => {
    const navigate = useNavigate();

    const filteredSdgs = (areaIndicator.indicatorDTO?.frameworksLevel1sDTOs)
        ? areaIndicator.indicatorDTO.frameworksLevel1sDTOs
            .filter(item => item.frameworkDTO.frameworkId === frameworkId)
            .flatMap(item =>
                item.level1sDTOs
                    .filter(level => level.frameworkId === frameworkId)
                    .map(level => level.levelN_ItemId)
            )
        : [];

    const handleClickOnName = () => {
        if (atPublicDashboard) return;
        navigate(`/plans/plans-explorer/${areaIndicator.area.plan.planUUID}?selectedAreaId=${encodeURIComponent(areaIndicator.area.areaId)}&selectedAreaIndicatorId=${encodeURIComponent(areaIndicator.areaIndicatorId)}`);
    }

    return (
        <Paper elevation={0} className= 'AreaIndicatorBasicCard-container' >
            <Box
                className='AreaIndicatorBasicCard-title'
                onClick={handleClickOnName}
                fontFamily={'Inter'}
                fontSize={12}
                color={'rgb(6, 6, 50)'}
                sx={{ cursor: 'pointer' }}
            >
                {areaIndicator.areaIndicatorName}
            </Box>
            <Box className='AreaIndicatorBasicCard-sdgs'
                display='flex' flexDirection='row' justifyContent='flex-start' alignItems='center'
                gap={1}
                padding={'5px 0px'} width={'100%'}
                sx={{ overflowY: 'auto' }}
            >
                {filteredSdgs.map((sdg, index) => (
                    (frameworkId === 2)
                        ? <SdgBullet
                            key={index}
                            sdg={sdg}
                            iconsSize={20}
                        />
                        : (frameworkId === 1)
                        ? < AUEStObjectiveBullet
                            key={index}
                            stObj={sdg}
                            iconsSize={20}
                        /> : null
                ))} 
            </Box>
        </Paper >
    );
}

export default AreaIndicatorBasicCard;